import { httpClient as t } from "../../../utils/http-client.mjs";
const p = async (e, r) => t.post("/api/purchase-service/buy-offer", e, {
  headers: {
    "accept-language": r
  }
});
export {
  p as buyOffer
};
